module.exports = __webpack_public_path__ + "img/TGHLogoBlue.93526a44.svg";